import { Observable } from "rxjs/Observable"

import * as actions from "../actions/action-types"

import {
    loginResponse,
    loginUnauthorized,
    loginError,
    forgotResponse,
    tokenRequest,
    tokenResponse,
    setHasBeenActive,
    timerRefresh
} from "../actions/authentication-actions"

import { login, forgot, refreshToken } from "../api/authentication-api"

import { tokenRefreshInterval } from "../config/application-definitions"

const {
    AUTHENTICATION_LOGIN_REQUEST,
    AUTHENTICATION_FORGOT_REQUEST,
    AUTHENTICATION_TOKEN_REQUEST,
    AUTHENTICATION_LOGIN_RESPONSE,
    TIMER_REFRESH
} = actions

export const requestLoginEpic = (action$, store) =>
    action$.ofType(AUTHENTICATION_LOGIN_REQUEST).mergeMap(action =>
        login(action.username, action.password)
            .map(data => loginResponse(data))
            .catch(error => Observable.of(handleError(error)))
    )

export const requestTokenEpic = action$ =>
    action$.ofType(AUTHENTICATION_TOKEN_REQUEST).mergeMap(action =>
        refreshToken(action.token)
            .map(data => tokenResponse(data))
            .catch(error => Observable.of(handleError(error)))
    )

function handleError(error) {
    if (error.status === 401 || error.status === 403)
        return loginUnauthorized(error)
    else return loginError(error)
}

export const requestForgotEpic = (action$, store) =>
    action$
        .ofType(AUTHENTICATION_FORGOT_REQUEST)
        .mergeMap(action => forgot(action.email))
        .map(data => forgotResponse(data))
        .catch(error => Observable.of(handleError(error)))

/*
  Wakes up every 30 mins after login to check if needs to rerequest token
*/
export const timerRefreshEpic = (action$, { getState }) =>
    action$
        .ofType(TIMER_REFRESH, AUTHENTICATION_LOGIN_RESPONSE)
        .delay(tokenRefreshInterval)
        .mergeMap(action => {
            const state = getState()
            const { hasBeenActive, token } = state.authentication

            if (hasBeenActive) {
                return Observable.of(
                    timerRefresh(),
                    tokenRequest(token),
                    setHasBeenActive(false)
                )
            } else {
                return Observable.of(timerRefresh(), setHasBeenActive(false))
            }
        })

/*
  Sets hasBeenActive to true if there is any user-induced network traffic
*/
const actionsToFilterOut = [
    actions.AUTHENTICATION_LOGIN_REQUEST,
    actions.AUTHENTICATION_LOGIN_RESPONSE,
    actions.AUTHENTICATION_LOGIN_UNAUTHORIZED,
    actions.AUTHENTICATION_LOGIN_ERROR,
    actions.UNAUTHENTICATED,
    actions.AUTHENTICATION_TOGGLE_FORM,
    actions.AUTHENTICATION_TOKEN_REQUEST,
    actions.AUTHENTICATION_TOKEN_RESPONSE,
    actions.SET_HAS_BEEN_ACTIVE,
    actions.TIMER_REFRESH,
    actions.AUTHENTICATION_FORGOT_REQUEST,
    actions.AUTHENTICATION_FORGOT_RESPONSE,
    actions.AUTHENTICATION_FORGOT_ERROR,
    actions.TIMER_REFRESH
]

const actionsToListenTo = Object.keys(actions).filter(
    action => actionsToFilterOut.indexOf(action) === -1
)

export const setHasBeenActiveEpic = action$ => {
    return action$
        .ofType(...actionsToListenTo)
        .debounceTime(1000)
        .map(action => setHasBeenActive(true))
}
